import React from "react";
import Box from "@mui/material/Box";
import Button from 'reactstrap/lib/Button'
import clsx from "clsx";

export default (function Submit(props){
	let { id, title: value, btnAnimation, submitProps } = props || {}
	let btnClassName = [];
	if(btnAnimation){
		btnClassName.push({ 'animated': true })
		btnClassName.push({ 'infinite': true })
		btnClassName.push(btnAnimation)
	}

	let { disabled } = submitProps || {}

	return <Box sx={{ paddingTop: '10px', justifyContent: 'center', display: 'flex' }}>
		<Button {...{ disabled, id }} className={clsx('btn-global', 'btn-block', btnClassName)} type={'submit'} color={'primary'}>{value || 'Submit'}</Button>
	</Box>
})